export default __webpack_public_path__ + "static/media/avatar2.49e6089c.png";